import * as React from 'react';

function SvgHeadsetVr(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M8 1.248c1.857 0 3.526.641 4.65 1.794a4.978 4.978 0 012.518 1.09C13.907 1.482 11.295 0 8 0 4.75 0 2.12 1.48.844 4.122a4.979 4.979 0 012.289-1.047C4.236 1.872 5.974 1.248 8 1.248z' />
			<path d='M12 12a3.988 3.988 0 01-2.786-1.13l-.002-.002a1.612 1.612 0 00-.276-.167A2.164 2.164 0 008 10.5c-.414 0-.729.103-.935.201a1.612 1.612 0 00-.277.167l-.002.002A4 4 0 114 4h8a4 4 0 010 8z' />
		</svg>
	);
}

export default SvgHeadsetVr;
